<template>
  <div class="container-fluid p-0 h-100">
      <div class="w-100 search-container">
            <img class ='icons-search' style="display: none;"
                :src="require('@/assets/icons/icon-search-gray.svg')"
                alt="search icon"
            />
            <input class="search-input mt-2 mb-2" v-model="search_input" type="text" placeholder="Buscar contenedores" />
      </div>
       <containersList></containersList> 
       <router-link v-if="view_role == 'Cargador'" :disabled = "!authorized('cargador')"  class="btn-circle" tag="button" to="NewExpedient" exact>+</router-link>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import containersList from '@/components/containersList.vue'
export default {
  name: 'Containers',
  components: {
      containersList
  },
  data() {
    return {
      search_input: "",
    }
  },
  computed: { 
     ...mapGetters(["view_role"]),
    ...mapGetters("user",{
      authorized: 'authorized',
    })  
  },
  mounted () {
    this.$store.commit('set_view_name', ['Expedientes'])
  },
}
</script>

<style lang= "scss" >

.search-container {
    background-color: $nav-background-mobile;
    padding: 5px 25px 5px 25px;
}

.navbar-aureal {
   box-shadow: 0px 3px 6px rgba(0,0,0,0.3) !important; 
}


 @media only screen and (min-width: $mobile-width) {
    .search-container {
        background-color: $nav-background-screen;
    }
  }

</style>
